
import { Vue, Component, Prop } from "vue-property-decorator";
import KeyStatus from "@/components/keys/KeyStatus.vue";

@Component({
  components: {
    KeyStatus,
  },
})
export default class RelayAlertKeys extends Vue {
  @Prop({ default: null })
  public relay: any;

  private IN_TRANSIT: string = "IN_TRANSIT";

  private lateKeys: any[] = [];
  private transitKeys: any[] = [];
  private alertKeyId: number = null;
  private currentKey: any = null;
  private newLocation: any = null;
  private transitRetrieveDialog: boolean = false;
  private reportMissingDialog: boolean = false;
  private newLocationDialog: boolean = false;
  private confirmTransitRetrieve: boolean = false;

  private mounted() {
    this.getAlertKeys();
  }

  private getAlertKeys() {
    return this.$store.dispatch("relays/getAlertKeys", {
      relayId: this.relay.id,
    }).then((res) => {
      this.lateKeys = [];
      this.transitKeys = [];
      if (res) {
        this.lateKeys = res.filter((key) => key.status === "LATE");
        this.transitKeys = res.filter((key) => key.status === "IN_TRANSIT");
      }
    });
  }

  private retrieveTransitKey() {
    this.transitRetrieveDialog = false;
    this.confirmTransitRetrieve = false;
    return this.$store.dispatch("keys/retrieveFromTransit", {
      relayId: this.relay.id,
      keyId: this.currentKey?.id,
    }).then((res) => {
      this.$store.commit("alerts/displaySuccess", {
        icon: "icon-picto_transit",
        msg: this.$i18n?.t("alerts.key.transitRetrieveSuccess", {
          key: this.currentKey.name,
          relay: res.Box?.Building?.Relays?.[0].name || "",
        }),
      });
      if (res) {
        this.$emit("reset");
        this.newLocation = res;
      }
      this.newLocationDialog = true;
      this.$emit("update");
      this.getAlertKeys();
    }).catch((err) => {
      this.$store.commit("alerts/displayError", {
        icon: "icon-picto_transit",
        msg: this.$i18n?.t("alerts.error.default"),
      });
    });
  }

  private reportMissingKey() {
    this.reportMissingDialog = false;
    return this.$store.dispatch("keys/reportMissing", {
      relayId: this.relay.id,
      keyId: this.currentKey?.id,
    }).then(() => {
      this.alertKeyId = this.currentKey.id;
      this.$store.commit("alerts/displaySuccess", {
        msg: this.$i18n?.t("common.emailSent"),
      });
    }).catch((err) => {
      this.$store.commit("alerts/displayError", {
        msg: err,
      });
    });
  }
}
